import { capitalizeFirstLetter } from 'utils/common'
import { TBankAccount } from './types'
import { CONTRACT_UUID_REGEX } from 'helper/common'

export const formatBankAccounName = (bankAccount: TBankAccount | null) => {
  if (!bankAccount) return ''
  if (bankAccount.nickname) {
    return bankAccount.nickname
  }
  return `${capitalizeFirstLetter(bankAccount.account_type)} ****${
    bankAccount.account_number
  }`
}

export const getPathWithoutLastUuid = (pathname: string) => {
  const segments = pathname.split('/')
  const lastSegment = segments[segments.length - 1]
  if (CONTRACT_UUID_REGEX.test(lastSegment)) {
    segments.pop()
  }
  return segments.join('/') || '/'
}
